import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";

class TemplateDropdown extends React.Component {
  handleTemplateSelect = (selectedOption, setFieldValue) => {
    const { handleTemplateSelect } = this.props;
    const e = { target: { value: selectedOption?.value } };

    // Call parent handler
    handleTemplateSelect(e, setFieldValue);

    // Update Formik field
    setFieldValue("templateId", selectedOption?.value || "");
  };

  render() {
    const { templates, setFieldValue, values } = this.props;

    const options = templates?.map((template) => ({
      value: template.templateId,
      label: template.templateTitle,
    }));

    const selectedOption = options?.find(
      (opt) => opt.value === values.templateId
    );

    return (
      <Select
        className="react-select-container"
        classNamePrefix="react-select"
        options={options}
        value={selectedOption || null}
        onChange={(selectedOption) =>
          this.handleTemplateSelect(selectedOption, setFieldValue)
        }
        placeholder="Select Templates"
        isClearable
      />
    );
  }
}

export default TemplateDropdown;

// ✅ PropTypes validation
TemplateDropdown.propTypes = {
  templates: PropTypes.arrayOf(
    PropTypes.shape({
      templateId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      templateTitle: PropTypes.string.isRequired,
    })
  ).isRequired,
  setFieldValue: PropTypes.func.isRequired,
  values: PropTypes.shape({
    templateId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  handleTemplateSelect: PropTypes.func.isRequired,
};
